import React from 'react';
import PropTypes from 'prop-types';
import { RESOURCE_GROUP_TYPES } from 'APP_ROOT/components/pages/dashboard/ResourceGroups/constants';

import { connect } from 'react-redux';
import Protected from '../../../common/protected';
import Vehicles from './Vehicles';
import Assets from './Assets';
import Geofences from './Geofences';

/**
 * Renders Vehicles, Assets and Geofences for the left panel.
 * */
export class ResourceGroups extends React.PureComponent {

    static propTypes = {
        user: PropTypes.object,
        features: PropTypes.object.isRequired,
        changeVehicleName: PropTypes.func.isRequired,
        setAllVisible: PropTypes.func.isRequired,
        setVisible: PropTypes.func.isRequired,
        // redux
        mainModuleGroupSelectedResourceType: PropTypes.string.isRequired
    }

    state = {
        editingNameFor: null,
        vehiclesGroupCollapsed: false,
        assetsGroupCollapsed: false,
        geofencesGroupCollapsed: false
    }

    setEditingItemName = (item, editing) => {
        this.setState(state => {
            if(editing) {
                return {
                    editingNameFor: item
                };
            } else { // !editing
                if (state.editingNameFor === item) {
                    return {
                        editingNameFor: null
                    };
                }
            }
        });
    }

    /* 
      Allows ResourceGroups to know which and control which Resource Groups are collapsed
    */
    toggleCollapsedForType = (type) => {
        switch (type) {
            case RESOURCE_GROUP_TYPES.VEHICLE:
                this.setState({
                    vehiclesGroupCollapsed: !this.state.vehiclesGroupCollapsed
                });
                break;
            case RESOURCE_GROUP_TYPES.ASSET:
                this.setState({
                    assetsGroupCollapsed: !this.state.assetsGroupCollapsed
                });
                break;
            case RESOURCE_GROUP_TYPES.GEOFENCE:
                this.setState({
                    geofencesGroupCollapsed: !this.state.geofencesGroupCollapsed
                });
                break;
            default:
                console.warn("ResourceGroups toggleCollapsedForType, unknown type: " + type);
                break;
        }
    }

    render() {
        const { user, features } = this.props;
        if (!user) return null;
        
        const commonProps = {
            ...this.state,
            ...this.props,
            selection: this.props.selectedRaven,
            setEditingItemName: this.setEditingItemName,
        }

        return (
            <div className="resource-groups">

                { this.props.mainModuleGroupSelectedResourceType === RESOURCE_GROUP_TYPES.VEHICLE ?
                    <Vehicles
                        {...commonProps}
                        collapsed={this.state.vehiclesGroupCollapsed}
                        toggleCollapsedForType={this.toggleCollapsedForType}
                    />
                :
                    null
                }
                {/*<div className="resource-group-separator"><div className="drop-shadow"></div></div>*/}

                <Protected resource="assets" action="read" gate={this.props.mainModuleGroupSelectedResourceType === RESOURCE_GROUP_TYPES.ASSET && features?.has_beacons}>
                    <Assets
                        {...commonProps}
                        stage={user.stage}
                        collapsed={this.state.assetsGroupCollapsed}
                        toggleCollapsedForType={this.toggleCollapsedForType}
                    />
                </Protected>

                {/*<div className="resource-group-separator"><div className="drop-shadow"></div></div>*/}

                <Protected resource="geofences" action="read" gate={this.props.mainModuleGroupSelectedResourceType === RESOURCE_GROUP_TYPES.GEOFENCE}>
                    <Geofences
                        {...commonProps}
                        stage={user.stage}
                        collapsed={this.state.geofencesGroupCollapsed}
                        toggleCollapsedForType={this.toggleCollapsedForType}
                    />
                    {/*<div className="resource-group-separator"></div>{/* REQUIRED, may look redudndant but simplifies/avoids bugs for div:nth-last-child(2) selector in _dashboard.scss */}
                </Protected>

            </div>
        );
    }

}

const mapStateToProps = (state, ownProps) => {
    if (!state.data.layoutTemplateModularFullscreenSharedState) {
        console.error("LayoutTemplateModularFullscreen mapStateToProps layoutTemplateModularFullscreenSharedState reducer property not found");
        return {};
    }

    const { layoutTemplateModularFullscreenSharedState } = state.data;

    return {
        ...layoutTemplateModularFullscreenSharedState // shared between modular fullscreen group and the main and user menus
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ResourceGroups);